import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateString' })
export class DateStringPipe implements PipeTransform {
  transform(value): string {
    if (!value)
      return '';
    let date = new Date(value);
    return date.toDateString() + ' ' + date.toLocaleTimeString();
  }
}
